import AppButton from "@common/components/app-button";
import {useNavigate} from "react-router-dom";
import {ReactComponent as PencilIcon} from "@assets/icons/pencil2.svg";
import {ReactComponent as AddDocumentIcon} from "@assets/icons/add-document.svg";
import {useModal} from "@common/hooks/use-modal";
import {ModalIds} from "@common/models/enums/modal-ids.enum";
import {readConvertAiModalState} from "../helpers/convert-ai-modal-state";

const NewArticleActions = () => {
    const navigate = useNavigate();
    const {openModal} = useModal();

    const clickNewArticle = () => {
        const aiState = readConvertAiModalState();
        if (aiState?.isProcessing) {
            openModal(ModalIds.ARTICLE_CONVERT_WITH_AI);
            return;
        }
        navigate(`./new`);
    };
    const openConvertModal = () => openModal(ModalIds.ARTICLE_CONVERT_WITH_AI);

    return (
        <div
            className="flex flex-col bg-surface-level-1 py-2 rounded-2xl border border-outline-mild shadow-lvl-2 overflow-hidden">
            <AppButton
                onClick={clickNewArticle}
                className="!p-0 !border-0 hover:bg-on-surface/5 !rounded-none"
                classNameContentWrapper="!block w-full">
                <div className="flex gap-4 py-2 pl-4 pr-6 whitespace-nowrap">
                    <PencilIcon/>
                    <span>Zacznij od nowa</span>
                </div>
            </AppButton>
            <AppButton
                onClick={openConvertModal}
                className="!p-0 !border-0 hover:bg-on-surface/5 !rounded-none"
                classNameContentWrapper="!block w-full">
                <div className="flex gap-4 py-2 pl-4 pr-6 whitespace-nowrap">
                    <AddDocumentIcon/>
                    <span>Wgraj dokument</span>
                </div>
            </AppButton>
        </div>
    )
}

export default NewArticleActions
